import { SharedApiV2 } from "mock-api/src/public-api";
import { PaginatedListQuery } from "src/app/core/request-v2-utils";

export class CarrierListQueryModel extends PaginatedListQuery {
  public constructor(args: ClassProperties<CarrierListQueryModel>) {
    super(args);
    this.searchQuery = args.searchQuery;
    this.carrierKey = args.carrierKey;
    this.carrierTypeName = args.carrierTypeName;
    this.isActive = args.isActive;
    this.name = args.name;
  }

  public readonly isActive?: boolean;
  public readonly carrierKey?: string;
  public readonly carrierTypeName?: string;
  public readonly searchQuery?: string;
  public readonly name?: string;

  public serialize(): SharedApiV2.GetCarrierQuery {
    return {
      ...this.serializeBase(),
      filter: {
        name: this.name,
        carrierKey: this.carrierKey,
        carrierTypeName: this.carrierTypeName,
        active: this.isActive,
        search: this.searchQuery,
      },
    };
  }
}
